import { makeRequest } from "./api";

export const FetchBathroom = async () => {
  return makeRequest("/api/admin/bathroom/fetch");
};

export const UpdateBathroom = async (
  itemName,
  otherItemName,
  startValue,
  endValue
) => {
  return makeRequest("/api/admin/bathroom/update", {
    method: "PUT",
    data: {
      itemName,
      otherItemName,
      startValue,
      endValue,
    },
  });
};
